import { PAYMENT_DETAILS } from 'actions/user'

export default (state = null, action) => {
    switch (action.type) {
        case PAYMENT_DETAILS:
            if (!!action.error) {
                return action.payload;
            } else {
                let isCheckDataPlain = false;
                if (!!action.payload.data.payment_details.check && action.payload.data.payment_details.check === action.payload.data.payment_details.check.toString()) {
                    isCheckDataPlain = true;
                }
                action.payload.data.isCheckDataPlain = isCheckDataPlain;
                return action.payload.data;
            }
    }

    return state;
}